module.exports = __webpack_public_path__ + "img/first-0.ff67c222.webp";